import React from 'react';
import { WeezHeader, Button, SplitContainer, Message, Icon, FrameCard, ToastContext } from '@weezevent/nacre';
import LoadingCard from '../../../../components/loadingCard';
import { useForm, fetcher } from '@weezevent/weezjs-core';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CategoryForm from './CategoryForm';
import { colors as clrs } from '../../../../components/color-picker';

import css from '../../chart-list.module.css';

function AddCategory({ organization, chartId }) {
    const { t } = useTranslation();
    const history = useHistory();
    const toast = React.useContext(ToastContext);
    const [loading, setLoading] = React.useState(false);

    const options = ['fr_FR', 'fr_CA', 'en_CA', 'en_US', 'en_GB', 'it_IT', 'es_ES'];
    const colors = [...clrs];

    const defaultColor = React.useCallback(items => {
        return Math.floor(Math.random() * items.length);
    });

    const defaultObject = React.useMemo(() => {
        return { index: 0, name: '', color: colors[defaultColor(colors)], general_admission: false, translations: { name: {} } };
    }, [defaultColor, colors]);

    const [form, setForm] = useForm(
        {
            categories: [{ ...defaultObject }]
        },
        {}
    );

    const handleAdd = React.useCallback(() => {
        let cat = form.categories;
        cat.push({ index: cat.slice(-1)[0].index + 1, name: '', color: colors[defaultColor(colors)], general_admission: false, translations: { name: {} } });
        setForm('categories', cat);
    }, [form.categories, defaultColor, colors]);

    const handleDelete = React.useCallback(
        index => {
            let cat = form.categories;
            cat.splice(index, 1);
            setForm('categories', cat);
        },
        [form.categories]
    );

    const handleBack = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/charts/${chartId}/categories`);
    }, [organization, chartId]);

    const handleSubmit = React.useCallback(() => {
        setLoading(true);
        fetcher
            .post(`/ticket/organizations/${organization.id}/charts/${chartId}/categories`, { data: form.categories })
            .then(() => {
                toast.success(t('ticket.charts.category.createSuccess', { count: form.categories.length }));
                history.push(`/ticket/O${organization.id}/charts/${chartId}/categories`);
            })
            .catch(() => {
                toast.error(t(`ticket.charts.category.creationError}`));
            })
            .finally(() => {
                setLoading(false);
            });
    }, [form.categories, organization, chartId]);

    const disableSubmit = React.useMemo(() => {
        return !form.categories.every(cat => cat.color !== null && cat.name !== '');
    }, [form, form.categories]);

    return (
        <>
            <WeezHeader
                backLink={{
                    onClick: () => handleBack()
                }}
                isFixed
                rightComponent={
                    <Button
                        primary
                        className={css['category-save-btn']}
                        label={
                            <>
                                <Icon className={css['category-save-mobile-icon']} name="save" size="regular" />
                                <span className={css['category-save-mobile-label']}>{t('ticket.common.action.save')}</span>
                            </>
                        }
                        disabled={disableSubmit}
                        onClick={handleSubmit}
                    />
                }
                title={t('ticket.charts.newCategory.newCategory')}
            />

            <SplitContainer
                additional={
                    <Message type="tips" title={t('notifications.tips_title')} mini>
                        <p>{t('notifications.category_tips')}</p>
                    </Message>
                }
            >
                <FrameCard title={t('ticket.creationEvent.stepSideBar.stepInfos')} subtitle={t('ticket.charts.newCategory.informations')}>
                    <LoadingCard loading={loading}>
                        {form.categories.map((category, index) => {
                            return (
                                <CategoryForm
                                    key={index}
                                    index={index}
                                    organization={organization}
                                    options={options}
                                    category={category}
                                    onDelete={handleDelete}
                                    form={form}
                                    setForm={setForm}
                                />
                            );
                        })}
                        <Button color="ticket" className={css['categories-increment-btn']} inverted label={t('ticket.charts.newCategory.newCategory')} onClick={handleAdd} />
                    </LoadingCard>
                </FrameCard>
            </SplitContainer>
        </>
    );
}

export default AddCategory;
